module.exports = __webpack_public_path__ + "static/media/matilde-special-adventour-impressed.26cb2d9d.png";